import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { createEvent, returnFromEditCreateEvent } from '../../actions';
import EventForm from './EventForm';
import { parseDate } from '../helpers/DateUtils';
import { CREATOR, GA_TRACKING_CREATE_PAGE } from '../helpers/AppConsts';
import ReactGA from 'react-ga';
import { Button, Icon } from 'semantic-ui-react';

const styles = {
  container: {
    minHeight: 'calc(100vh - 200px)',
    backgroundColor: '#f5f5f5',
    padding: '40px 20px',
  },
  content: {
    maxWidth: '800px',
    margin: '0 auto',
  },
  card: {
    backgroundColor: 'white',
    borderRadius: '12px',
    boxShadow: '0 2px 12px rgba(0,0,0,0.1)',
    padding: '30px',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '25px',
    paddingBottom: '20px',
    borderBottom: '1px solid #eee',
  },
  headerIcon: {
    backgroundColor: '#569556',
    borderRadius: '10px',
    width: '45px',
    height: '45px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: '15px',
  },
  title: {
    margin: 0,
    fontSize: '1.5rem',
    color: '#333',
  },
  subtitle: {
    margin: 0,
    color: '#666',
    fontSize: '0.9rem',
  },
  buttonGroup: {
    marginTop: '25px',
    paddingTop: '20px',
    borderTop: '1px solid #eee',
    display: 'flex',
    gap: '10px',
  },
};

const EventCreate = ({ currentUserEmail, createEvent, returnFromEditCreateEvent }) => {
  useEffect(() => {
    ReactGA.ga('send', 'pageview', GA_TRACKING_CREATE_PAGE);
  }, []);

  const onSubmit = (formValues) => {
    formValues.event_organizer = currentUserEmail;
    formValues.userEmail = currentUserEmail;
    formValues.event_date = parseDate(formValues.event_year, formValues.event_month, formValues.event_day);
    formValues.event_notes = formValues.notes ? formValues.notes : 'Not specified.';
    createEvent(formValues);
  };

  const onReturn = () => {
    returnFromEditCreateEvent();
  };

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <div style={styles.card}>
          <div style={styles.header}>
            <div style={styles.headerIcon}>
              <Icon name="plus" size="large" style={{ color: 'white', margin: 0 }} />
            </div>
            <div>
              <h1 style={styles.title}>Create Event</h1>
              <p style={styles.subtitle}>Add a new bridge event</p>
            </div>
          </div>

          <EventForm onSubmit={onSubmit} />

          <div style={styles.buttonGroup}>
            <Button basic onClick={onReturn}>
              <Icon name="arrow left" /> Back to Events
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    currentUserEmail: CREATOR,
  };
};

export default connect(mapStateToProps, { createEvent, returnFromEditCreateEvent })(EventCreate);
